import { useEffect, useState } from "react";
import DashboardComponentWrapper from '../../../components/dashboard/DashboardComponentWrapper';
import TabComponent from '../../../components/ui/TabComponent';
import Table from '../../../components/ui/Table';
import { useGetWorkflowAuditsQuery } from '../../../features/shared/workflowApi';
import { useNavigate } from "react-router-dom";
import { icons } from '../../../assets';
import DashboardNavItem from '../../../components/dashboard/DashboardNavItem/DashboardNavItem';
import TableActionsComponent from '../../../components/ui/Table/TableActionsComponent';

const WorkflowAudit = () => {
  const navigate = useNavigate();
  const tabComponents = {
    'Audit': () => <AuditTable />,
  };

  const navItemsObj = [
    {
      label: 'Go back',
      action: () => navigate(-1),
      bgColor: '#0898A0',
      img: icons.closeNav,
    }
  ];

  const renderNavItems = () => {
    return (
      <DashboardNavItem
        navItems={[]}
        navItemsObj={navItemsObj}
        tab={''}
        setTab={() => { }}
      />
    )
  }

  return (
      <DashboardComponentWrapper
        title="Workflow Audit"
        pageDetails="View Audit for your Workflow"
        renderNavItems={renderNavItems}
      >
        <>
          <TabComponent
            components={tabComponents}
          />
        </>
      </DashboardComponentWrapper>
  )
};

export default WorkflowAudit;


const AuditTable = () => {
  const { data: auditsResponse } = useGetWorkflowAuditsQuery();
  const audits = auditsResponse?.data || [];
  const header = [
    { field: 'eventDateTime', headerName: 'Time' },
    { field: 'recordId', headerName: 'Record Id' },
    { field: 'recordType', headerName: 'Record Type' },
    { field: 'principalId', headerName: 'Principal Id'},
    { field: 'dataSnapShop', headerName: 'Data SnapShop' },
    { field: 'eventType', headerName: 'Event Type'},
    { field: 'user', headerName: 'User' },
    { field: 'auserWorkFlowLevel', headerName: 'User WorkFlow Level'},
    {
      field: "description",
      headerName: "Description",
    }
  ];

  return (
    <div className="accordion !w-full h-[65vh] text-left mt-6">
      <Table data={audits} header={header}        
      />
    </div>
  )
}